
export function background(overall: number | string) {
    return overall === '-' || (+overall) < 1.0
        ? "bg-red-200"
        : (+overall) < 2.0
        ? "bg-yellow-200/80"
        : (+overall) < 3.0
        ? "bg-lime-200"
        : "bg-green-600/50"
}